import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { IoCreate, IoTrash } from 'react-icons/io5'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, GrupoDespesa, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { createTheme, ThemeProvider } from '@mui/material'
import { selectUser } from '../Redux/userSlice'
import { Link, useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import moment from 'moment'
import { GrupoDespesaService } from '../../Pages/GrupoDespesa/GrupoDespesaService'
import { Tooltip } from 'react-tooltip'
import { FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'

type Props = {
    grupoDespesa: GrupoDespesa[],
    handleUpdateGrupoDespesaList: () => void
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number,
    description: string,
    id_sgrupo_despesa: number,
    classificacao: string,
    dt_cadastro: string,
    desc_sgrupo: string
}

export const GridGrupoDespesa = React.memo(({ grupoDespesa, handleUpdateGrupoDespesaList }: Props) => {


    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_grupoDesp")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_grupoDesp") || '')
                : {
                    acao: true,
                    description: true,
                    desc_sgrupo: true,
                    classificacao: true,
                    dt_cadastro: true,
                }
        )
    }, [])

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_grupoDesp")

    let json: any = {
        acao: true,
        description: true,
        desc_sgrupo: true,
        classificacao: true,
        dt_cadastro: true,
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_grupoDesp") || '')
    }
        
    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }

                newColumnVisibility.acao = json.acao
                newColumnVisibility.description = json.description
                newColumnVisibility.desc_sgrupo = json.desc_sgrupo
                newColumnVisibility.classificacao = json.classificacao
                newColumnVisibility.dt_cadastro = json.dt_cadastro

            }
        }

    }, [])
    
    */

    const [idGrupoDesp, setIdGrupoDesp] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [grupoDespesas, setGruposDespesas] = useState<GrupoDespesa[]>([])
    const [nomeGrupoDesp, setNomeGrupoDesp] = useState("")

    let user = useSelector(state => selectUser(state))


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setGruposDespesas(grupoDespesa)
    }, [grupoDespesa])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_grupoDesp", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await GrupoDespesaService.Delete(idGrupoDesp, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Grupo Despesa excluído com sucesso`)

                handleUpdateGrupoDespesaList()

                //setGruposDespesas(await GrupoDespesaService.Filter('', '', ''))
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir o grupo de despesa. Por favor, tente novamente`)

        }
        
    }, [idGrupoDesp])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_grupo_despesa")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        
        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeGrupoDesp("")
        }
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeGrupoDesp("")
    }, [])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light'
                        ? '#fff' // modo claro
                        : '#475569', //modo escuro
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaGrupoDespesaEdit = (id: number) => {
        navigate(`/grupoDespesa/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const colunas = useMemo<MRT_ColumnDef<GrupoDespesa>[]>(
        () => [

            {
                accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: false, enableSorting: false, size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    const navegar = () => {
                        navegarTelaGrupoDespesaEdit(rowData.id)
                    }

                    const handleExcluirClick = () => {

                        const timerExcluir = setTimeout(() => {
                            setIdGrupoDesp(rowData.id)
                            setNomeGrupoDesp(rowData.description)
                            setModalShow(true)
    
                            let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                            if (divPerfil) {
                                divPerfil.classList.add('hidden')
                            }
    
                            let menuFiltro = document.getElementById("divMenuFiltroGrupoDesp") as HTMLDivElement
                            let menuInputs = document.getElementById("divInputsGrupoDesp") as HTMLDivElement
    
                            if (menuFiltro) {
    
                                menuInputs.classList.add("invisible")
    
                                const timer = setTimeout(() => {
                                    menuFiltro.classList.remove("max-h-[390px]")
                                    menuFiltro.classList.add("max-h-[0px]")
                                    Inputfocus()
                                    clearTimeout(timer)
                                }, 100)
                            }

                            clearTimeout(timerExcluir)
                        }, 0);

                        

                    }

                    return (
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`}>
                                <RiEdit2Fill size="20px" />

                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />

                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    )
                }
            },

            {
                accessorKey: 'description', visibleInShowHideMenu: true, header: 'Descrição', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.description ? rowData.description : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'desc_sgrupo', visibleInShowHideMenu: true, header: 'SubGrupo Despesa', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.desc_sgrupo ? rowData.desc_sgrupo : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'classificacao', visibleInShowHideMenu: true, header: 'Classificação', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.classificacao ? rowData.classificacao : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

                }
            }

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: grupoDespesas,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir o grupo de despesa - ${nomeGrupoDesp || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}

            />

        </>
    )

})